import type { LayoutRectangle, View } from 'react-native';

/**
 * Measure the size of an element in the window.
 */
export function measureNodeInWindow(node: HTMLElement | View): LayoutRectangle {
    if (node instanceof HTMLElement) {
        const rect = node.getBoundingClientRect();
        return {
            x: rect.left,
            y: rect.top,
            width: rect.width,
            height: rect.height,
        };
    }
    throw new Error(
        'measureNodeInWindow should be called with a native node and not a react-native component. Use a <View /> or <DOMView />'
    );
}
